/* eslint-disable */

export const phoneRegExp =
  /^\s*(?:\+?(\d{1,4}))?[-. (]*(\d{1,3})[-. )]*(\d{1,3})[-. ]*(\d{1,3})[-. ]*(\d{1,3})(?: *x(\d+))?\s*$/;

export const internationalPhoneRegExp = /^[0-9\-().\s]{10,14}$/;

export const decimalRegEx = (maxDigits) =>
  new RegExp(`^-?(\\d+)((\\,|\\.)(\\d{0,${maxDigits}}))?$`, 'gm');
